import createAction from '../../common/services/create-action';

export const STOP_EDITING_COMMENT = 'comment/STOP_EDITING';
export const stopEditingComment = createAction(STOP_EDITING_COMMENT);
